import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import palette from "../../../theme/palette";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
  },
  odds: {
    padding: "5px",
    marginLeft: "6px",
    marginRight: "6px",
    marginTop: "6px",
    marginBottom: "6px",
    border: "1px solid",
    minWidth: "89px",
    textAlign: "center",
    cursor: "pointer",
  },
  selectedodds: {
    padding: "5px",
    marginLeft: "6px",
    marginRight: "6px",
    border: "1px solid",
    minWidth: "89px",
    textAlign: "center",
    color: palette.common.white,
    backgroundColor: "#0069E2",
    cursor: "pointer",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  icons: {
    width: "80%",
    height: "80%",
    margin: "10%",
  },
  noBreak: {
    whiteSpace: "nowrap",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

function OddsChooser(props) {
  let oddsArray = props.chosenValues;
console.log(props);
  function markSelected(value) {
    const editMode = props.id ? false : true;
    props.updateOdds(
      value.eventId,
      value.marketId,
      value.selectionId,
      props.id,
      editMode
    );
  }

  const classes = useStyles();

  function translateHUB(val){
    if(val==="D"){
      return "U";
    }else if(val==="A"){
      return "B";
    }
    return val;
  }

  function renderHUB(value, clsArr) {
    return (
      <div
        key={value.selectionId}
        className={clsx(clsArr.join(", "))}
        onClick={markSelected.bind(null, value)}
      >
        <div>{translateHUB(value.selectionValue)}</div>
        <div>{parseFloat(value.selectionOdds).toFixed(2)}</div>
      </div>
    );
  }

  function renderVinner(value, clsArr) {
    return (
      <div
        className={clsx(clsArr.join(", "))}
        key={value.selectionId}
        onClick={markSelected.bind(null, value)}
      >
        <div>{value.selectionShortName}</div>
        <div>{parseFloat(value.selectionOdds).toFixed(2)}</div>
      </div>
    );
  }

  function renderChooser(value, clsArr) {

    if (
      value.selectionValue === "H" ||
      value.selectionValue === "D" ||
      value.selectionValue === "A"
    ) {
      return renderHUB(value, clsArr);
    } else {
      return renderVinner(value, clsArr);
    }
  }

  return (
    <div className={classes.container}>
      {oddsArray &&
        oddsArray.map((value, index) => {
          const clsArr = [];

          if (props.selectionId == value.selectionId) {
            clsArr.push(classes.selectedodds);
          } else {
            clsArr.push(classes.odds);
          }

          return renderChooser(value, clsArr);
        })}
    </div>
  );
}

export default OddsChooser;
